import apiClient from '../apiClient';
import { PUT_RESTAURANT_PROFILE_URL } from '../apiUrl';

const putRestaurantProfileApi = (id, data) => {
  return apiClient.put(PUT_RESTAURANT_PROFILE_URL(id), data);
};

export default putRestaurantProfileApi;
